/**
 * Created by Denis Kuzin on 25 december 2024
 */

const Map2dControls = cc.Node.extend({
    ctor: function (map2dView) {
        this._super();

        let dragUnit, templateUnit, touchUnit, hoverUnit, touchFog, touchDecorator, baseTouch;

        this.debugId = "Map2dControls";

        this.setContentSize2(map2dView.width, map2dView.height);
        this.setAnchorPoint(0.5, 0.5);
        this.setAlignment({ align: "center" }, { align: "center" });

        const releaseUnit = function (cancelled) {
            const unit = dragUnit;

            touchUnit = undefined;
            hoverUnit = undefined;
            touchFog = undefined;
            touchDecorator = undefined;
            dragUnit = undefined;
            templateUnit = undefined;
            baseTouch = undefined;

            if (unit) {
                unit.onDragEnd(cancelled);
            }
        };

        const pressHandler = cleverapps.UI.onPressed(this, (touch) => {
            if (touchUnit && InfoView.IsDisplayedFor(touchUnit)) {
                touchUnit.onClickEvent(touch);
                return true;
            }

            InfoView.CloseInfo();
            map2dView.map2d.customers && map2dView.map2d.customers.selectCustomer(undefined);

            if (cleverapps.config.demoMode && !cleverapps.unitsDemoMode.isSelectedUnit(this.unit)) {
                cleverapps.unitsDemoMode.clearSelectUnit();
            }
        });

        const pointerHandler = cleverapps.pointerManager.create(this, {
            filter: function (touch) {
                if (cleverapps.config.debugMode && touch) {
                    const cell = map2dView.getCellByTouch(touch);
                    console.log("cell", cell);
                }

                const unitOrDecorator = touch && map2dView.findTouchUnit(touch);
                const unit = unitOrDecorator instanceof Unit && unitOrDecorator;
                const decorator = unitOrDecorator instanceof Map2dDecorator && unitOrDecorator;

                if (unit && !unit.isBlocked()) {
                    releaseUnit(true);
                    touchUnit = unit;
                    baseTouch = touch;
                    return true;
                }

                const fog = touch && map2dView.findTouchFog(touch);
                if (fog && fog.touchFilter()) {
                    return false;
                }

                if (fog) {
                    releaseUnit(true);
                    touchFog = fog;
                    baseTouch = touch;
                    return true;
                }

                if (decorator) {
                    releaseUnit(true);
                    touchDecorator = decorator;
                    baseTouch = touch;
                    return true;
                }

                if (cleverapps.skins.getSlot("walkingWorkersSkins")) {
                    return true;
                }

                if (InfoView.IsOpened()) {
                    return true;
                }

                const orangerySelection = Map2d.currentMap.orangery && Map2d.currentMap.orangery.selected;
                if (orangerySelection && !cleverapps.focusManager.isFocused()) {
                    return true;
                }

                return false;
            },

            onClick: function (touch) {
                const cell = map2dView.getCellByTouch(touch);
                const floatCell = map2dView.getCellByTouch(touch, true);

                map2dView.map2d.onDebugCellClick(cell);

                const orangerySelection = Map2d.currentMap.orangery && Map2d.currentMap.orangery.selected;
                if (orangerySelection && !cleverapps.focusManager.isFocused()) {
                    map2dView.map2d.createUnitFromOrangery(orangerySelection, cell);
                    return;
                }

                if (baseTouch === touch) {
                    if (touchUnit && map2dView.map2d.isUnitClick(touchUnit) && touchUnit.onClickEvent(touch)) {
                        releaseUnit();
                        return;
                    }

                    if (touchFog && map2dView.map2d.isFogClick(touchFog)) {
                        touchFog.onClickEvent(touch);
                        releaseUnit();
                        return;
                    }

                    if (touchDecorator) {
                        touchDecorator.onClickEvent(touch);
                        releaseUnit();
                        return;
                    }

                    releaseUnit();
                }

                map2dView.onCellClick(cell, cc.pSub(floatCell, cell));
            },

            onDragMoveNotThrottled: function (touch) {
                if (baseTouch !== touch) {
                    return;
                }

                if (dragUnit) {
                    dragUnit.onFollowPointer(touch);
                }
            },

            onDragStart: function (touch) {
                if (baseTouch !== touch) {
                    return;
                }

                const game = typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation;
                const isFocused = cleverapps.focusManager.isFocused() && !["StartQuest"].includes(cleverapps.focusManager.focus);
                const isTutorial = game && game.tutorial && game.tutorial.isActive() || cleverapps.tutorial && cleverapps.tutorial.isActive();

                if (isFocused && !isTutorial) {
                    return;
                }

                const orangery = Map2d.currentMap.orangery;

                if (orangery && orangery.selected && cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.b)) {
                    templateUnit = orangery.selected;
                    return true;
                }

                if (touchUnit && map2dView.map2d.isUnitClick(touchUnit)) {
                    if (touchUnit.onDragStart(touch)) {
                        dragUnit = touchUnit;
                        return true;
                    }
                }
            },

            onDragMove: function (touch) {
                if (baseTouch !== touch) {
                    return;
                }

                if (dragUnit) {
                    dragUnit.onDragMove();
                    return;
                }

                if (templateUnit) {
                    const cell = map2dView.getCellByTouch(touch);
                    map2dView.map2d.createUnitFromOrangery(templateUnit, cell);
                }
            },

            onDragEnd: function (touch) {
                if (baseTouch !== touch) {
                    return;
                }

                releaseUnit();
            },

            onMouseMove: cleverapps.timeredThrottle(200, (touch) => {
                const unit = map2dView.findTouchUnit(touch);
                if (unit && (!hoverUnit || hoverUnit !== unit)) {
                    if (hoverUnit && hoverUnit.onGetView()) {
                        hoverUnit.onGetView().outline(true);
                    }

                    const unitView = unit.onGetView();
                    if (unitView && !map2dView.hoveredInfoView) {
                        unitView.outline();
                    }
                }

                if (!unit && hoverUnit && hoverUnit.onGetView()) {
                    hoverUnit.onGetView().outline(true);
                }

                hoverUnit = unit;
            })
        });

        map2dView.map2d.stopDragging = this.createListener(() => {
            releaseUnit(true);
        });

        this.toggleControls = this.createListener((enabled) => {
            pointerHandler.setEnabled(enabled);
            pressHandler.setEnabled(enabled);
            releaseUnit(true);
        });

        if (typeof Map2dLocation !== "undefined") {
            Map2dLocation.currentLocation.on("stop", this.toggleControls.bind(this, false));
        }

        this.getUnitTouch = function () {
            if (dragUnit) {
                return baseTouch;
            }
        };
        this.forceMoveUnit = function () {
            if (dragUnit) {
                dragUnit.onDragMove(baseTouch);
            }
        };

        cleverapps.focusManager.registerControl("map2d", this.toggleControls);
    }
});